package com.eladfinish.bible.contest.ui.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.eladfinish.bible.contest.ui.components.toolbar.LocalToolbarConfigurator
import com.eladfinish.bible.contest.ui.components.toolbar.ToolbarConfigurationHolder
import com.eladfinish.bible.contest.ui.components.toolbar.ToolbarConfigurator
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarNavigationMode
import com.eladfinish.bible.contest.ui.components.toolbar.host.AnyToolbarConfiguration

@Composable
fun WithScreenConfiguration(
    decorateConfig: ToolbarNavigationMode.() -> ToolbarNavigationMode = { this },
    onToolbarConfiguratorReady: (ToolbarConfigurator) -> Unit = {},
    content: ScreenConfigurationContent,
) {
    val toolbarConfigurationHolder = remember { ToolbarConfigurationHolder() }

    var isLoading by remember { mutableStateOf(false) }

    val toolbarConfigurator = remember(decorateConfig) {
        object : ToolbarConfigurator {
            override fun setConfiguration(config: AnyToolbarConfiguration?, owner: Any?) {
                toolbarConfigurationHolder.set(
                    configuration = config?.let {
                        it.copy(navigationMode = it.navigationMode.decorateConfig())
                    },
                    owner = owner,
                )
            }

            override fun updateConfiguration(update: AnyToolbarConfiguration.() -> AnyToolbarConfiguration) {
                toolbarConfigurationHolder.update(update)
            }

            override fun addUpdate(
                owner: Any?,
                update: AnyToolbarConfiguration.() -> AnyToolbarConfiguration,
            ): () -> Unit = toolbarConfigurationHolder.addUpdate(owner, update)
        }
    }

    LaunchedEffect(toolbarConfigurator) {
        onToolbarConfiguratorReady(toolbarConfigurator)
    }

    val screenLoaderConfigurator = ScreenLoaderVisibilityConfigurator { isLoading = it }

    CompositionLocalProvider(
        LocalScreenLoaderVisibilityConfigurator provides screenLoaderConfigurator,
        LocalToolbarConfigurator provides toolbarConfigurator,
    ) {
        content.render(
            toolbarConfiguration = toolbarConfigurationHolder.configuration,
            isLoading = isLoading,
        )
    }
}
